import { render } from "./AddNewNotePriority.vue?vue&type=template&id=606e035a"
import script from "./AddNewNotePriority.vue?vue&type=script&lang=js"
export * from "./AddNewNotePriority.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__